import { withInstall } from '/@/neolix-utils/src/index'
import dropdown from './src/Dropdown.vue'

export * from './src/typing'
export const Dropdown = withInstall(dropdown)
